import React from 'react';

export class ParentLine extends React.Component {
	render() {
		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList ? 'div' : 'td';

		return <Component className="DataSourceColumn parent-line-column" />;
	}
}

export class ParentLineLast extends React.Component {
	render() {
		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList ? 'div' : 'td';

		return <Component className="DataSourceColumn last-parent-line-column" />;
	}
}

export class ParentLineStraight extends React.Component {
	render() {
		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList ? 'div' : 'td';

		return <Component className="DataSourceColumn straight-parent-line-column" />;
	}
}
